import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { VaccinesResponse } from 'types/immunization';

export const influenzaVaccineKeys = {
  all: ['influenzaVaccines'] as const,
};

export function useInfluenzaVaccines(enabled: boolean) {
  return useQuery<VaccinesResponse>({
    queryKey: influenzaVaccineKeys.all,
    queryFn: () => get('influenzaVaccines') as Promise<VaccinesResponse>,
    enabled,
    staleTime: 0,
  });
}
